import type { SpriteAnimationDefinition } from "./types";

export function animationFrameAt(
  animation: SpriteAnimationDefinition,
  actionTime: number
): number {
  const frameCount = Math.max(1, animation.end - animation.start + 1);
  const elapsedFrames = Math.max(0, Math.floor(actionTime * animation.frameRate));
  const frameOffset =
    animation.repeat === -1
      ? elapsedFrames % frameCount
      : Math.min(elapsedFrames, frameCount - 1);
  return animation.start + frameOffset;
}
